module.exports = __webpack_public_path__ + "static/media/icon_upload.c732ac86.svg";